import { DocumentSnapshot } from "store/firebase";
import "firebase/firestore";
import { User } from "./reducer";

export const normalizeDisplayName = (
  displayName?: string | null
): string | null => {
  const trimmed = displayName?.trim();
  return trimmed ? trimmed : null;
};

export const getDisplayNameOrEmail = (
  displayName?: string | null,
  email?: string | null
): string => {
  return normalizeDisplayName(displayName) ?? email ?? "";
};

export const userFromDoc = (doc: DocumentSnapshot | null): User => {
  return {
    id: doc?.id ?? "no-id?",
    email: doc?.id ?? "no-email?",
    displayName: normalizeDisplayName(doc?.data()?.displayName),
    hasChampionBelt: doc?.data()?.hasChampionBelt === true,
  };
};
